import { defineComponent as _defineComponent } from 'vue'
import { DynamicList } from '@/interfaces/model/general/dynamicList';
import { computed } from 'vue';
import BaseFormCard from '@/views/base/BaseFormCard.vue';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'BulkSuspendDynamicListDialog',
  props: {
    value: { type: Boolean },
    selectedDynamicLists: null
  },
  emits: ["input", "suspend"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void;
  (e: 'suspend'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  selectedDynamicLists: DynamicList[];
};

const m = defineMessages({
  updateCancelConfirmation: '選択した{count}件の更新を中止しますか?',
  updateCancelMessage:
    '「実行する」をクリックすると、選択された{count}件のチェックリストの更新を停止します。',
});




const model = computed({
  get: () => props.value,
  set: (value) => emit('input', value),
});

const closeDialog = () => {
  model.value = false;
};

const handleSuspendClick = () => {
  emit('suspend');
  closeDialog();
};

const handleCancelClick = () => {
  closeDialog();
};

return { __sfc: true,m, props, emit, model, closeDialog, handleSuspendClick, handleCancelClick, BaseFormCard, sharedMessages }
}

})